const PAGE_PARAM = 'pg';

export function getFiltersFromURL() {
  const params = new URLSearchParams(window.location.search);
  const filters = {};

  for (const [key, value] of params.entries()) {

    if (
      key === 'query' ||
      key === PAGE_PARAM ||
      key === 'sortVal' ||
      key === 'sortOrder'
    ) {
      continue;
    }

    if (!filters[key]) filters[key] = [];
    filters[key].push(value);
  }

  return filters;
}

export function getPageFromURL() {
  const params = new URLSearchParams(window.location.search);
  return parseInt(params.get(PAGE_PARAM), 10) || 1;
}

// export function buildQueryParams(filters, page, query) {

//   const params = new URLSearchParams();

//   Object.keys(filters).forEach(key => {
//     params.delete(key);
//   });

//   if (query) {
//     params.set('query', query);
//   }

//   Object.entries(filters).forEach(([key, values]) => {
//     values.forEach(value => params.append(key, value));
//   });

//   if (page > 1) {
//     params.set(PAGE_PARAM, page);
//   }

//   return params.toString();
// }

export function buildQueryParams(filters, page, query) {

  // Start from CURRENT URL
  // const params = new URLSearchParams(window.location.search);
  const params = new URLSearchParams();

  // Remove existing filter keys
  Object.keys(filters).forEach(key => {
    params.delete(key);
  });

  // Update query
  if (query) {
    params.set('query', query);
  } else {
    params.delete('query');
  }

  // Update filters
  Object.entries(filters).forEach(([key, values]) => {
    values.forEach(value => params.append(key, value));
  });

  // Update page ONLY if it changed
  if (page > 1) {
    params.set(PAGE_PARAM, page);
  } else {
    params.delete('pg')
  }

  return params.toString();
}

export function syncURL(filters, page, query) {

  const params = buildQueryParams(filters, page, query);

  const basePath = window.location.pathname;
  const hash = window.location.hash;

  const newUrl = params
    ? `${basePath}?${params}${hash}`
    : `${basePath}${hash}`;

  window.history.replaceState({}, '', newUrl);
}

export function getQueryFromURL() {
  const params = new URLSearchParams(window.location.search);
  return params.get('query') || '';
}